import type { TFunction } from 'i18next'

/**
 * Die App hat keine Datums-Bibliothek, und die Aktivitaeten formatieren ihre
 * Uhrzeiten ueber `navigator.language` (siehe `Activity/useHours.ts`). Das wird
 * hier fortgefuehrt, statt fuer den Chat eine zweite Konvention einzufuehren.
 */
export const messageTime = (iso: string): string =>
    new Date(iso).toLocaleTimeString(navigator.language, {
        hour: '2-digit',
        minute: '2-digit',
    })

const startOfDay = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()

/**
 * Trennt den Verlauf nach Tagen. "Heute" und "Gestern" tragen die meiste
 * Information, alles Aeltere bekommt ein Datum.
 */
export const dayLabel = (iso: string, t: TFunction): string => {
    const date = new Date(iso)
    const days = Math.round(
        (startOfDay(new Date()) - startOfDay(date)) / 86400000,
    )

    if (days <= 0) return t('contact.day.today', 'Heute')
    if (days === 1) return t('contact.day.yesterday', 'Gestern')

    return date.toLocaleDateString(navigator.language, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    })
}

/** Gleicher Tag? Entscheidet ueber den Trenner zwischen zwei Nachrichten. */
export const isSameDay = (a: string, b: string): boolean =>
    startOfDay(new Date(a)) === startOfDay(new Date(b))
